import { WidgetRepo } from '../repo/widgetRepo';

export class CookieUtils {
  widgetRepo: WidgetRepo;
  d = new Date();

  constructor() {
    this.widgetRepo = new WidgetRepo();
  }

  setCookie(cname: string, cvalue: string, exdays: number) {
    this.d.setTime(this.d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + this.d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  getCookie(name) {
    let cookies;
    cookies = document.cookie
      .split(';')
      .map(cookie => cookie.split('='))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {},
      );
    return cookies[name];
  }

  cookieProcessor(
    cookieName,
    cookieValue,
    eventName,
    expiry,
    env,
    id,
    eventProperties?: any,
  ) {
    this.setCookie(cookieName, cookieValue, expiry);
    this.widgetRepo.sendWidgetEvent(eventName, env, id, eventProperties).then();
  }

  cookieClickHandler(
    cookieName,
    cookieValue,
    eventN,
    exDay,
    env,
    id,
    eventProperties?: any,
  ) {
    if (this.getCookie(cookieName) !== cookieValue) {
      this.cookieProcessor(
        cookieName,
        cookieValue,
        eventN,
        exDay,
        env,
        id,
        eventProperties,
      );
    }
  }

  addItemInLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }
}
